module.exports = __webpack_public_path__ + "d60a435926da0fa4b6d333bad5d8df79.jpg";